import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import styles from './styles.scss';

const propTypes = {
  filename: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  defaultMetadata: PropTypes.shape({
    title: PropTypes.string,
  }),
};
const defaultProps = {
  defaultMetadata: {},
};

const MediaGalleryThumbnail = ({ url, defaultMetadata: { title }, filename }) => (
  <>
    <div className={styles.thumbnailContainer}>
      <img src={url} alt="thumbnail" className={styles.thumbnail} />
    </div>
    <div className={styles.title}>
      {title || filename}
    </div>
    <div className={styles.filename}>
      {filename}
    </div>
  </>
);

MediaGalleryThumbnail.propTypes = propTypes;
MediaGalleryThumbnail.defaultProps = defaultProps;

MediaGalleryThumbnail.fragments = {
  medium: gql`
    fragment MediaGalleryThumbnailMedium on Medium {
      filename
      url
      defaultMetadata {
        title
      }
    }
  `,
};

export default MediaGalleryThumbnail;
